export default function init()
{
    const stickyCards = document.querySelectorAll('.product-fieldset-wrapper .product-fieldset.section  .product-card--sticky');
    if (stickyCards.length > 0) {
        stickyCards.forEach(card => {
            window.addEventListener('scroll', function() {
                const cardTop = card.getBoundingClientRect().top;
                if (cardTop <= 5) {
                    card.classList.add('fix-scroll');
                } else {
                    card.classList.remove('fix-scroll');
                }

                if(!card.classList.contains('with-promotion')) {
                    const promo = card.querySelector('.promotion-container');
                    if(promo) {
                        card.classList.add('with-promotion');
                    }
                }
                
            });
        });
    }
}
